import React from 'react';
import PropTypes from 'prop-types';
import { currency } from 'Helpers/Formats';
import AccountStatus from 'Components/UI/AccountStatus';
import { withStyles } from '@material-ui/core/styles';

export const styles = theme => ({
  root: {
    display: 'flex',
  },
  text: {
    display: 'inline-block',
    width: theme.dimensions.xxs,
  },
});
function View({ account, classes }) {
  const showIcon = account.attr('lastSync') || Boolean(account.attr('isManaged'));
  return (
    <td className="balance">
      <div className={classes.root}>
        {account.attr('balance') !== null && currency(account.attr('balance'), true)}
        {showIcon && <AccountStatus resource={account} syncGood tooltip />}
      </div>
    </td>
  );
}

View.propTypes = {
  classes: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
};

export default withStyles(styles)(View);
